import { createRouter, createWebHistory } from 'vue-router'

const routes = [
	// {
	// 	path: '/',
	// 	name: '导航',
	// 	component: () => import('../views/HeadMenu/headmenu.vue')
	// },

	{
		path: '/login',
		name: '登录',
		component: () => import('../views/login.vue')
	},
	{
		path: '/register',
		name: '注册',
		component: () => import('../views/register.vue')
	},
	{
		path: '/SearchCertificate',
		name: '查询证书',
		component: () => import('../views/SearchCertificate.vue')
	},
	{
		path: '/',
		name: '首页',
		component: () => import('../views/graph_homepage.vue')
	},
	{
		path: '/details',
		name: '页面信息框架',
		component: () => import('../views/details.vue'),
		redirect: '/newsinfo',
		children: [
			{
				path: '/userInfo',
				name: '个人中心',
				component: () => import('../views/userInfo.vue')
			},
			
			{
				path: '/signUp',
				name: '报名',
				component: () => import('../views/signUp.vue')
			},
			// 主页
			{
				path: '/newsinfo',
				name: '新闻列表',
				component: () => import('../views/newsinfo.vue')
			},
			{
				path: '/newsdetail',
				name: '新闻详情信息',
				component: () => import('../views/newcontain/newsdetail.vue')
			},
			{
				path: '/precompetitions',
				name: '往届赛事',
				component: () => import('../views/precompetitions.vue')
			},
			{
				path: '/learn',
				name: '学习专区',
				component: () => import('../views/learn.vue')
			},
			{
				path: '/download',
				name: '下载专区',
				component: () => import('../views/download.vue')
			},
			{
				path: '/about',
				name: '关于大赛',
				component: () => import('../views/about.vue')
			},
			{
				path: '/content',
				name: '详情页',
				component: () => import('../views/content.vue')
			},
		]
	},
	{
		path: '/minadmin',
		name: '区域赛管理员主页',
		component: () => import('../components/minadmin.vue'),
		children: [
			// 主页
			{
				path: '/qusession',
				name: '区域赛标签管理',
				component: () =>
					import('../components/minadmin/session.vue')
			},
			//类别管理界面
			{
				path: '/qunewkind',
				name: '区域赛新闻类别管理界面',
				component: () =>
					import('../components/minadmin/newkind.vue')
			},
			{
				path: '/qunewsedit',
				name: '区域新闻编辑界面',
				component: () =>
					import('../components/minadmin/newslist.vue')
			},]
	},
	{
		path: '/guanhomepage',
		name: '管理员主页',
		component: () => import('../components/admin.vue'),
		children: [
			// 主页
			{
				path: '/guanlihomepage',
				name: '管理员管理首页',
				component: () =>
					import('../components/admin/homepage.vue')
			},
			//新闻编辑界面
			{
				path: '/newsedit',
				name: '新闻编辑界面',
				component: () =>
					import('../components/admin/newslist.vue')
			},
			
			//赛届管理界面
			{
				path: '/session',
				name: '赛届管理界面',
				component: () =>
					import('../components/admin/session.vue')
			},

			//类别管理界面
			{
				path: '/newkind',
				name: '新闻类别管理界面',
				component: () =>
					import('../components/admin/newkind.vue')
			},

			//图文管理界面
			{
				path: '/picmanage',
				name: '图文管理界面',
				component: () =>
					import('../components/admin/picmanage.vue')
			},
			//图文管理界面

			{
				path: '/display',
				name: '布局管理',
				component: () =>
					import('../components/admin/display.vue')
			},
			{
				path: '/competitionnote',
				name: '备注管理',
				component: () =>
					import('../components/admin/cmpnote.vue')
			},

			//竞赛管理界面
			{
				path: '/competition',
				name: '竞赛管理',
				component: () =>
					import('../components/admin/competition.vue')
			},
			//竞赛管理界面
			{
				path: '/competitionarea',
				name: '赛区管理',
				component: () =>
					import('../components/admin/competitionarea.vue')
				},

			//赛程competitiontime
			{
				path: '/competitiontime',
				name: '竞赛时间',
				component: () =>
					import('../components/admin/competitiontime.vue')
			},
			{
				path: '/Certificatemanage',
				name: '竞赛证书管理',
				component: () =>
					import('../components/admin/Certificatemanage.vue')
			},
			//支持单位support
			{
				path: '/support',
				name: '赞助商',
				component: () =>
					import('../components/admin/support.vue')
			},

			// statistical 统计信息
			{
				path: '/statistical',
				name: '统计信息',
				component: () =>
					import('../components/admin/statistical.vue')
			},

			// 用户统计信息
			{
				path: '/usersmanage',
				name: '用户管理',
				component: () =>
				import('../components/admin/usersmanage.vue')
			},

			// 往期回顾
			{
				path: '/previous',
				name: '往期回顾',
				component: () =>
				import('../components/admin/others.vue')
			},

			//signup 报名管理
			{
				path: '/signupmanage',
				name: '报名信息管理',
				component: () =>
				import('../components/admin/signupmanage.vue')
			},

			//resource
			{
				path: '/resource',
				name: '资源管理',
				component: () =>
				import('../components/admin/resource.vue')
			},
			{
				path: '/test',
				name: 'test',
				component: () => import('../views/test.vue')
			},

			{
				path: '/adminmanage',
				name: 'adminmanage',
				component: () => import('../views/adminmanage.vue')
			},
			
		]
	}
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
})

/*配置路由的导航守卫*/
/*有一些路由不能直接进入，必须进行安全验证(登录验证),
给这些路由再跳入之前进行导航守卫(请求的拦截)的配置*/
/* to:要进入的路由   from:当前路由  next:函数，能够继续访问路由*/

router.beforeEach((to, from, next) => {
//配置守卫路由集合
const routList = ['/userInfo','/signUp,','/minadmin', '/qusession','/qunewkind','/qunewsedit','/index',
'/guanlihomepage','/newsedit','/session','/newkind','/picmanage','/display','/competition',
'/competitiontime','/support','/statistical','/usersmanage','/previous','/signupmanage',
'/resource','/adminmanage',]
let user = window.sessionStorage.getItem('account');
//判断to 转入的路由是不是涉及到 守卫路由集合
  if(routList.indexOf(to.path)>=0){
	  if(user==null||user==''){
		  //没登陆控制路由的跳转到登录路由中去
		  router.push('/login')
		  router.to('/login')
		  location.reload()
	  }
  }
next()
})

export default router